export default {
    title: 'Auswertungen',
    description: 'Hier können Sie die ausgewählten Beschaffungen als Auswertung exportieren. Wählen Sie dazu das gewünschte Format aus und klicken Sie auf "Jetzt exportieren".',
    noExportOptionsAvailable: 'Keine Exportoptionen verfügbar.',
    exportNow: 'Jetzt exportieren',
    definedColumns: 'Es werden folgende Spalten exportiert:',
    availablePlaceholders: 'Es stehen Ihnen folgende Platzhalter zur Verfügung:'
}